module.exports = __webpack_public_path__ + "media/customizations/regencyatmontaine/logo-new-0b596b3ae1bc4503308bbfed9d594db8.png";